import React from "react";
import Head from "next/head";

import ContestsMain from "@/components/contests/contests-main";

import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const Contests = () => {
  return (
    <>
      <Head>
        <title>{seoData.CONTESTS.title}</title>
        <SeoMetaData data={seoData.CONTESTS} />
      </Head>

      <ContestsMain />
    </>
  );
};

export default Contests;
